// extracted by mini-css-extract-plugin
export default {"wrapper":"RulesPageTableVadalityCell_wrapper__znbV-"};